function e(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!+\/])/g,"\\$1").replace(/ /g,".")}`}export{e as c};
//# sourceMappingURL=classes-to-selector.js.map
